import { render, staticRenderFns } from "./UserAddressSelector.vue?vue&type=template&id=88c074d0&scoped=true"
import script from "./UserAddressSelector.vue?vue&type=script&lang=ts"
export * from "./UserAddressSelector.vue?vue&type=script&lang=ts"
import style0 from "./UserAddressSelector.vue?vue&type=style&index=0&id=88c074d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c074d0",
  null
  
)

export default component.exports